// Yield & variance — spec §9.5. Always computed on dry mass.
import { toDecimal } from './internal/decimal-utils.js';
const YIELD_DP = 4;
/** yield_dry = Σ outputs dry_kg / Σ inputs dry_kg, as a percentage. Zero (rather
 * than a divide-by-zero) when there were no dry inputs to speak of. */
export function yieldDryPct(inputsDryKg, outputsDryKg) {
    const inputs = toDecimal(inputsDryKg);
    if (inputs.lte(0)) {
        return 0;
    }
    const outputs = toDecimal(outputsDryKg);
    return outputs.div(inputs).times(100).toDecimalPlaces(YIELD_DP).toNumber();
}
/** Actual yield minus the recipe's expected yield — positive is better than recipe. */
export function yieldVariancePct(actualPct, expectedPct) {
    return toDecimal(actualPct).minus(toDecimal(expectedPct)).toDecimalPlaces(YIELD_DP).toNumber();
}
//# sourceMappingURL=yieldCalc.js.map